import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faComment } from '@fortawesome/free-solid-svg-icons';
import { useSocket } from '../../contexts/SocketContext';
import { useAuth } from '../../hooks/useAuth';
import { useMessagesUI } from '../../contexts/MessagesUIContext';
import '../../styles/MessageToast.css';

const MessageToast = () => {
  const [toasts, setToasts] = useState([]);
  const { user } = useAuth();
  const { socket } = useSocket();
  const { isOpen, openMessages } = useMessagesUI();

  useEffect(() => {
    if (!user || !socket) return;

    const handleNewMessage = (messageEvent) => {
      // Messages modal already shows live updates — skip background toast
      if (isOpen) return;
      // Closing a task should not ping the recipient as a new unread message
      if (messageEvent.markUnread === false || messageEvent.status === 'closed') return;

      const toast = {
        id: Date.now() + Math.random(),
        ...messageEvent,
        timestamp: Date.now(),
      };
      setToasts((prev) => [...prev, toast]);

      setTimeout(() => {
        removeToast(toast.id);
      }, 10000);
    };

    socket.on('new_message', handleNewMessage);
    return () => socket.off('new_message', handleNewMessage);
  }, [socket, user, isOpen]);

  const removeToast = (toastId) => {
    setToasts((prev) => prev.filter((t) => t.id !== toastId));
  };

  const openConversation = (toast) => {
    removeToast(toast.id);
    openMessages({ conversationId: toast.conversationId });
  };

  if (!user) return null;

  return (
    <div className="message-toast-container">
      {toasts.map((toast) => (
        <div key={toast.id} className="message-toast" onClick={() => openConversation(toast)}>
          <div className="message-toast-content">
            <div className="message-toast-icon">
              <FontAwesomeIcon icon={faComment} />
            </div>
            <div className="message-toast-text">
              <div className="message-toast-title">
                {toast.kind === 'agent'
                  ? `New message from ${toast.senderName || 'Clinical Assistant'}`
                  : (toast.objectType && toast.objectType !== 'general' && toast.kind === 'task'
                    ? `New task message from ${toast.senderName}`
                    : `New message from ${toast.senderName}`)}
              </div>
              <div className="message-toast-subtitle">{toast.objectLabel}</div>
              <div className="message-toast-body">{toast.preview}</div>
            </div>
            <button
              className="message-toast-close"
              onClick={(e) => {
                e.stopPropagation();
                removeToast(toast.id);
              }}
              aria-label="Close"
              type="button"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MessageToast;
